/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Emailinvalid1Inputs */

const zh_profile_emailinvalid1 = /** @type {(inputs: Profile_Emailinvalid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入有效的邮箱地址`)
};

const en_profile_emailinvalid1 = /** @type {(inputs: Profile_Emailinvalid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a valid email address`)
};

const es_profile_emailinvalid1 = /** @type {(inputs: Profile_Emailinvalid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce una dirección de correo válida`)
};

/**
* | output |
* | --- |
* | "Please enter a valid email address" |
*
* @param {Profile_Emailinvalid1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const profile_emailinvalid1 = /** @type {((inputs?: Profile_Emailinvalid1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Emailinvalid1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_profile_emailinvalid1(inputs)
	if (locale === "en") return en_profile_emailinvalid1(inputs)
	return es_profile_emailinvalid1(inputs)
});
export { profile_emailinvalid1 as "profile_emailInvalid" }